import { format, toDate } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import { cn } from '@components/primitives/utilities';

import { isCurrentYear } from '@utils/ago';

import css from './styles.module.css';

export function getLocalTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export interface TimezoneTableProps {
  className?: string;
  value: string | number | Date;
}

export function TimezoneTable({ className, value }: TimezoneTableProps) {
  const formatStr = isCurrentYear(value)
    ? 'dd MMM HH:mm:ss'
    : 'dd MMM yyyy HH:mm:ss';

  return (
    <dl className={cn(css.timestampTable, className)}>
      <div className={css.timestampTableRow}>
        <dt>
          <span>{getLocalTimezone()}</span>
        </dt>
        <dd>{format(value, formatStr)}</dd>
      </div>

      <div className={css.timestampTableRow}>
        <dt>
          <span>UTC</span>
        </dt>
        <dd>{formatInTimeZone(value, 'UTC', formatStr)}</dd>
      </div>

      <div className={css.timestampTableRow}>
        <dt>
          <span>Timestamp</span>
        </dt>
        <dd>{toDate(value).toISOString()}</dd>
      </div>
    </dl>
  );
}
